// extracted by mini-css-extract-plugin
export default {"preloader":"PreloaderStyles_preloader__-GqxA","fadeOut":"PreloaderStyles_fadeOut__XxgCP"};